"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var selectFilter_1 = require("./selectFilter");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.action('clearFilter')(function clearFilter(actionSource) {
    selectFilter_1.default('All', actionSource);
});
//# sourceMappingURL=clearFilter.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-filter-actions/lib/actions/clearFilter.js
// module id = 2323
// module chunks = 46 105